import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-34b1e622"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "logeed-box"
};
const _hoisted_2 = ["src"];
const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "ic_nav"
}, null, -1));
const _hoisted_4 = {
  class: "logeed-select"
};
const _hoisted_5 = {
  class: "logeed-cell"
};
const _hoisted_6 = {
  class: "logged-option disabled text-overflow"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock(_Fragment, null, [_createElementVNode("div", {
    class: "logged-container",
    onMouseenter: _cache[1] || (_cache[1] = $event => $setup.showOptions = true),
    onMouseleave: _cache[2] || (_cache[2] = $event => $setup.showOptions = false)
  }, [_createElementVNode("div", _hoisted_1, [_createElementVNode("img", {
    class: "avatar",
    src: $setup.isSvip || $setup.isSlideVip ? require('./ic_vip.png') : require('./ic_normal.png')
  }, null, 8, _hoisted_2), _hoisted_3]), _createElementVNode("div", _hoisted_4, [_withDirectives(_createElementVNode("div", _hoisted_5, [_createElementVNode("div", _hoisted_6, _toDisplayString($props.nickname), 1), _createElementVNode("div", {
    class: "logged-option",
    onClick: _cache[0] || (_cache[0] = $event => $setup.showQuit = true)
  }, "退出登录")], 512), [[_vShow, $setup.showOptions]])])], 32), _withDirectives(_createVNode($setup["ConfirmDialog"], {
    title: "确定退出当前账号吗？",
    confirmBtnText: "确定",
    onConfirm: $setup.logout,
    onCancel: _cache[3] || (_cache[3] = $event => $setup.showQuit = false)
  }, null, 512), [[_vShow, $setup.showQuit]])], 64);
}